import { staticPath } from '@/utils/baseUrl.js'
import Index from './pages/index/index.vue'
import ResetPassword from './pages/resetPassword/resetPassword.vue'
import ExplainCard from './pages/accountAuthor/explainCard/explainCard.vue'
import addExplainCard from './pages/accountAuthor/explainCard/addExplainCard.vue'
import Video from './pages/sucaiku/video.vue'
import Audio from './pages/sucaiku/audio.vue'
import Image from './pages/sucaiku/image.vue'
import SystemSettings from './pages/system-settings/system-settings.vue'
import CreateSystem from './pages/system-settings/create-system.vue'
import RakeBack from './pages/rakeBack/rakeBack'
import CapitalIncome from './pages/capitalIncome/capitalIncome.vue'
import WithdrawalManage from './pages/capitalIncome/withdrawalManage.vue'
import WithdrawalRecord from './pages/capitalIncome/withdrawalRecord.vue'
import ToPublicPayment from './pages/capitalIncome/toPublicPayment.vue'
import paymentBill from './pages/capitalIncome/paymentBill.vue'
import applyPaymentHistory from './pages/capitalIncome/applyPaymentHistory.vue'
// import GettingUserInformation from './pages/gettingUserInformation/gettingUserInformation.vue'
import SpecialColumn from './pages/dy/courseContent/specialColumn/index.vue'
import CreateColumn from './pages/dy/courseContent/specialColumn/createColumn.vue'
import Chapter from './pages/dy/courseContent/specialColumn/chapter/index.vue'
import CourseGuide from './pages/guide/course/index.vue'
import courseShowHide from './pages/courseShowHide/index.vue'
// import DyAccount from './pages/accountAuthor/dyAccount.vue'
import Comment from './pages/comment/comment.vue'
import Message from './pages/message/message.vue'
import detailMessage from './pages/message/detailMessage.vue'
import ShareInfo from './pages/shopManagement/shareInfo.vue'
import SharePromotion from './pages/sharePromotion/sharePromotion.vue'
import ShortMessage from './pages/shortMessage/shortMessage.vue'
import ShortMessageHistory from './pages/shortMessage/history/history.jsx'
import SendOrder from './pages/sendOrder/sendOrder.vue'

import ExchangeCourse from './pages/sendOrder/exchangeCourse.vue'
import PreRecharge from './pages/sendOrder/preRecharge.vue'

import OpearateSharePromotion from './pages/sharePromotion/opearateSharePromotion.vue'

import Seckill from './pages/dy/seckill/seckill.vue'
import CreateSeckill from './pages/dy/seckill/createSeckill.vue'
import storCenter from './pages/dy/orderManage/storCenter/index.vue'
import trafficCenter from './pages/dy/orderManage/trafficCenter/index.vue'

export default [
    {
        path: staticPath + 'index',
        component: Index,
        meta: {
            id: 1,
            title: '首页',
            pathName: staticPath + 'index'
        }
    },
    {
        path: staticPath + 'resetPassword',
        name: 'ResetPassword',
        component: ResetPassword,
        meta: {
            pathName: staticPath + 'basicInfo'
        }
    },
    {
        path: staticPath + 'explainCard',
        name: 'explainCard',
        component: ExplainCard,
        meta: {
            pathName: staticPath + 'explainCard'
        }
    },
    {
        path: staticPath + 'addExplainCard',
        name: 'addExplainCard',
        component: addExplainCard,
        meta: {
            title: '添加讲解卡',
            pathName: staticPath + 'explainCard'
        }
    },
    {
        path: staticPath + 'video', // 素材库视频
        component: Video,
        name: 'Video',
        meta: {
            id: 11,
            title: '视频',
            pathName: staticPath + 'video'
        }
    },
    {
        path: staticPath + 'audio', // 素材库音频
        component: Audio,
        name: 'Audio',
        meta: {
            id: 12,
            title: '音频',
            pathName: staticPath + 'audio'
        }
    },
    {
        path: staticPath + 'image', // 素材库音频
        component: Image,
        name: 'Image',
        meta: {
            id: 13,
            title: '图片',
            pathName: staticPath + 'image'
        }
    },
    {
        path: staticPath + 'systemSettings',
        component: SystemSettings,
        name: 'SystemSettings',
        meta: {
            title: '账号管理',
            id: 19,
            pathName: staticPath + 'systemSettings'
        }
    },
    {
        path: staticPath + 'createSystem',
        component: CreateSystem,
        name: 'CreateSystem',
        meta: {
            title: '添加人员',
            leval: 2,
            pathName: staticPath + 'systemSettings'
        }
    },
    {
        path: staticPath + 'editSystem/:id',
        component: CreateSystem,
        name: 'EditSystem',
        meta: {
            title: '权限变更',
            leval: 2,
            pathName: staticPath + 'systemSettings'
        }
    },
    {
        path: staticPath + 'editSystemInfo/:id',
        component: CreateSystem,
        name: 'EditSystemInfo',
        meta: {
            title: '编辑',
            leval: 2,
            pathName: staticPath + 'systemSettings'
        }
    },
    {
        path: staticPath + 'rakeBack',
        component: RakeBack,
        name: 'RakeBack',
        meta: {
            title: '返佣明细',
            id: 20,
            pathName: staticPath + 'rakeBack'
        }
    },
    {
        path: staticPath + 'capitalIncome',
        name: 'CapitalIncome',
        component: CapitalIncome,
        meta: {
            title: '资金收益',
            id: 21,
            pathName: staticPath + 'capitalIncome'
        }
    },
    {
        path: staticPath + 'withdrawalManage',
        name: 'WithdrawalManage',
        component: WithdrawalManage,
        meta: {
            title: '提现管理',
            pathName: staticPath + 'capitalIncome',
            leval: 2
        }
    },
    {
        path: staticPath + 'depositHistory',
        component: () => import('./pages/capitalIncome/depositHistory.vue'),
        name: 'DepositHistory',
        meta: {
            title: '扣除记录',
            leval: 3,
            pathName: staticPath + 'capitalIncome'
        }
    },
    {
        path: staticPath + 'withdrawalRecord',
        name: 'WithdrawalRecord',
        component: WithdrawalRecord,
        meta: {
            title: '提现记录',
            leval: 2,
            pathName: staticPath + 'capitalIncome'
        }
    },
    {
        path: staticPath + 'toPublicPayment',
        name: 'ToPublicPayment',
        component: ToPublicPayment,
        meta: {
            title: '对公打款',
            pathName: staticPath + 'toPublicPayment'
        }
    },
    {
        path: staticPath + 'paymentBill',
        name: 'paymentBill',
        component: paymentBill,
        meta: {
            title: '账单',
            // leval: 2,
            pathName: staticPath + 'toPublicPayment',
        }
    },
    {
        path: staticPath + 'applyPaymentHistory',
        name: 'applyPaymentHistory',
        component: applyPaymentHistory,
        meta: {
            title: '申请记录', // 对公打款申请记录
            // leval: 2,
            pathName: staticPath + 'toPublicPayment',
        }
    },
    // {
    //     path: staticPath + 'gettingUserInformation',
    //     name: 'GettingUserInformation',
    //     component: GettingUserInformation,
    //     meta: {
    //         title: '用户信息获取',
    //         id: 22,
    //         pathName: staticPath + 'gettingUserInformation'
    //     }
    // },
    {
        path: staticPath + 'specialColumn',
        component: SpecialColumn,
        meta: {
            id: 6,
            title: '课程',
            pathName: staticPath + 'specialColumn'
        }
    },
    //storCenter
    {
        path: staticPath + 'storCenter',
        component: storCenter,
        meta: {
            // id: 6,
            title: '存储管理',
            pathName: staticPath + 'storCenter'
        }
    },
    {
        path: staticPath + 'trafficCenter',
        component: trafficCenter,
        meta: {
            // id: 6,
            title: '流量管理',
            pathName: staticPath + 'trafficCenter'
        }
    },
	{
	    path: staticPath + 'courseGuide',
	    component: CourseGuide,
	    meta: {
	        // id: '',
	        title: '课程上传教程>',
	        pathName: staticPath + 'specialColumn'
	    }
	},
    {
        path: staticPath + 'createColumn/:id?', // 新建课程
        component: CreateColumn,
        name: 'CreateColumn',
        meta: {
            // id: 222
            title: '新建课程',
            saveBtnFlag: true,
            pathName: staticPath + 'specialColumn'
        }
    },
    {
        path: staticPath + 'editColumn/:id', // 修改课程
        component: CreateColumn,
        name: 'EditColumn',
        meta: {
            // id: 223,
            title: '编辑课程',
            pathName: staticPath + 'specialColumn'
        }
    },
    {
        path: staticPath + 'editColumnOther/:id', // 修改课程
        component: CreateColumn,
        name: 'EditColumnOther',
        meta: {
            // id: 223,
            title: '编辑课程',
            pathName: staticPath + 'specialColumn'
        }
    },
    {
        path: staticPath + 'preivewColumn/:id', // 查看课程
        component: CreateColumn,
        name: 'PreivewColumn',
        meta: {
            // id: 223,
            title: '查看课程',
            pathName: staticPath + 'specialColumn'
        }
    },
    {
        path:staticPath + 'systemOpenPlatform/:id?',
        component: () => import('./pages/system-settings/systemOpenPlatform.vue'),
        meta:{
            title: '开放平台',
            pathName: staticPath + 'systemOpenPlatform'
        }
    },
    {
        path: staticPath + 'chapter/:id/:type?',
        component: Chapter,
        meta: {
            title: '章节',
            pathName: staticPath + 'specialColumn'
        }
    },
    {
        path: staticPath + 'courseSetMeal',
        component: () => import ('./pages/courseSetMeal/courseSetMeal.vue'),
        meta: {
            title: '课程套餐',
            pathName: staticPath + 'courseSetMeal'
        }
    },
    {
        path: staticPath + 'addCourseSetMeal',
        component: () => import ('./pages/courseSetMeal/addCourseSetMeal.vue'),
        meta: {
            title: '课程套餐',
            pathName: staticPath + 'courseSetMeal'
        }
    },
    {
        path:staticPath + 'courseShowHide',
        component: courseShowHide,
        meta:{
            title:'课程显示/隐藏',
            pathName: staticPath + 'courseShowHide',
            id: 24
        }
    },
    {
        path:staticPath + 'newGuide/:id?',
        component: () => import('./pages/helpCenter/newGuide.vue'),
        meta:{
            title: '新手必看',
            pathName: staticPath + 'newGuide'
        }
    },
    {
        path:staticPath + 'exportHistory',
        component: () => import('./pages/exportHistory/exportHistory.vue'),
        meta:{
            // title: '导出记录',
            pathName: staticPath + 'exportHistory'
        }
    },
    {
        path: staticPath + 'dyAccountIndex',
        name: 'DyAccount',
        component: () => import('./pages/accountAuthor/dyAccount.vue'),
        meta: {
            pathName: staticPath + 'dyAccountIndex'
        }
    },
    {
        path: staticPath + 'newDyAccountIndex',
        name: 'newDyAccount',
        component: () => import('./pages/accountAuthor/newDyAccount.vue'),
        meta: {
            pathName: staticPath + 'newDyAccountIndex'
        }
    },
    {
        path: staticPath + 'ksAccountIndex',
        name: 'KsAccount',
        component: () => import('./pages/accountAuthor/dyAccount.vue'),
        meta: {
            pathName: staticPath + 'ksAccountIndex'
        }
    },
    {
        path: staticPath + 'qualifications',
        name: 'Qualifications',
        component: () => import('./pages/qualifications/qualifications.vue'),
            meta: {
            pathName: staticPath + 'qualifications'
        }
    },
    {
        path: staticPath + 'createQualifications/:id?',
        name: 'CreateQualifications',
        component: () => import('./pages/qualifications/createQualifications.vue'),
        meta: {
            pathName: staticPath + 'qualifications'
        }
    },
    {
        path: staticPath + 'previewQualifications/:id',
        name: 'PreviewQualifications',
        component: () => import('./pages/qualifications/createQualifications.vue'),
        meta: {
            pathName: staticPath + 'qualifications'
        }
    },
    // {
    //     path: staticPath + 'qualificationsOld',
    //     name: 'QualificationsOld',
    //     component: () => import('./pages/qualifications-disuse/qualifications.vue'),
    //         meta: {
    //         pathName: staticPath + 'qualificationsOld'
    //     }
    // },
    // {
    //     path: staticPath + 'createQualifications/:id?',
    //     name: 'CreateQualificationsOld',
    //     component: () => import('./pages/qualifications-disuse/createQualifications.vue'),
    //     meta: {
    //         pathName: staticPath + 'qualificationsOld'
    //     }
    // },
    // {
    //     path: staticPath + 'previewQualifications/:id',
    //     name: 'PreviewQualificationsOld',
    //     component: () => import('./pages/qualifications-disuse/createQualifications.vue'),
    //     meta: {
    //         pathName: staticPath + 'qualificationsOld'
    //     }
    // },
    {
        path: staticPath + 'comment',
        name: 'Comment',
        component: Comment,
        meta: {
            pathName:  staticPath + 'comment'
        }
    },
    {
        path: staticPath + 'comment',
        name: 'Comment',
        component: Comment,
        meta: {
            pathName:  staticPath + 'comment'
        }
    },
    {
        path: staticPath + 'sharePromotion',
        name: 'SharePromotion',
        component: SharePromotion,
        meta: {
            pathName:  staticPath + 'sharePromotion'
        }
    },
    {
        path: staticPath + 'message',
        name: 'Message',
        component: Message,
        meta: {
            pathName:  staticPath + 'message'
        }
    },
	{
	    path: staticPath + 'detailMessage',
	    name: 'detailMessage',
	    component: detailMessage,
	    meta: {
	        pathName:  staticPath + 'message'
	    }
	},
    {
        path: staticPath + 'shareInfo',
        name: 'shareInfo',
        component: ShareInfo,
        meta: {
            pathName:  staticPath + 'shareInfo'
        }
    },
    {
        path: staticPath + 'question',
        component: () => import('./pages/question/question.vue'),
        meta: {
            pathName:  staticPath + 'question'
        }
    },
    {
        path: staticPath + 'createQuestion',
        component: () => import('./pages/question/createQuestion.vue'),
        name: 'CreateQuestion',
        meta: {
            pathName:  staticPath + 'question'
        }
    },
    {
        path: staticPath + 'previewQuestion/:id',
        component: () => import('./pages/question/createQuestion.vue'),
        name: 'PreviewQuestion',
        meta: {
            pathName:  staticPath + 'question'
        }
    },
    {
        path: staticPath + 'editQuestion/:id',
        component: () => import('./pages/question/createQuestion.vue'),
        name: 'EditQuestion',
        meta: {
            pathName:  staticPath + 'question'
        }
    },
    {
        path: staticPath + 'exam',
        component: () => import('./pages/exam/index.vue'),
        name: 'Exam',
        meta: {
            pathName:  staticPath + 'exam'
        }
    },
    {
        path: staticPath + 'createExam',
        component: () => import('./pages/exam/createExam.vue'),
        name: 'CreateExam',
        meta: {
            pathName:  staticPath + 'exam'
        }
    },
    {
        path: staticPath + 'editExam/:id',
        component: () => import('./pages/exam/createExam.vue'),
        name: 'EditExam',
        meta: {
            pathName:  staticPath + 'exam'
        }
    },
    {
        path: staticPath + 'batchQuestion',
        component: () => import('./pages/batchQuestion/index.vue'),
        name: 'BatchQuestion',
        meta: {
            pathName:  staticPath + 'batchQuestion'
        }
    },
    {
        path: staticPath + 'dataOverview',
        component: () => import('./pages/dataCenter/dataOverview.vue'),
        name: 'DataOverview',
        meta: {
            pathName:  staticPath + 'dataOverview'
        }
    },
    {
        path: staticPath + 'dataIndex',
        component: () => import('./pages/dataCenter/dataIndex.vue'),
        name: 'DataIndex',
        meta: {
            pathName:  staticPath + 'dataIndex'
        }
    },
    {
        path: staticPath + 'courseSales',
        component: () => import('./pages/dataCenter/courseSales.vue'),
        name: 'CourseSales',
        meta: {
            pathName:  staticPath + 'courseSales'
        }
    },
    {
        path: staticPath + 'revenueRanking',
        component: () => import('./pages/dataCenter/revenueRanking.vue'),
        name: 'revenueRanking',
        meta: {
            pathName:  staticPath + 'revenueRanking'
        }
    },
    {
        path: staticPath + 'accessStatistics',
        component: () => import('./pages/dataCenter/accessStatistics.vue'),
        name: 'accessStatistics',
        meta: {
            pathName:  staticPath + 'accessStatistics'
        }
    },
    {
        path: staticPath + 'shortMessage',
        component: ShortMessage,
        name: 'ShortMessage',
        meta: {
            pathName:  staticPath + 'shortMessage'
        }
    },
    {
        path: staticPath + 'shortMessageHistory',
        component: ShortMessageHistory,
        name: 'ShortMessageHistory',
        meta: {
            pathName:  staticPath + 'shortMessage'
        }
    },
    {
        path: staticPath + 'sendOrder',
        component: SendOrder,
        name: 'SendOrder',
        meta: {
            pathName:  staticPath + 'sendOrder'
        }
    },
    {
        path: staticPath + 'exchangeCourse',
        component: ExchangeCourse,
        name: 'ExchangeCourse',
        meta: {
            pathName:  staticPath + 'exchangeCourse'
        }
    },
    {
        path: staticPath + 'preRecharge',
        component: PreRecharge,
        name: 'PreRecharge',
        meta: {
            pathName:  staticPath + 'preRecharge'
        }
    },
    {
        path: staticPath + 'shareQualification',
        component: () => import('./pages/qualifications/shareQualification.vue'),
        name: 'ShareQualification',
        meta: {
            pathName:  staticPath + 'qualifications'
        }
    },
    {
        path: staticPath + 'opearateSharePromotion/:id?',
        component: OpearateSharePromotion,
        name: 'OpearateSharePromotion',
        meta: {
            pathName:  staticPath + 'sharePromotion'
        }
    },
    {
        path: staticPath + 'refund',
        component: () => import('./pages/refund/refund.vue'),
        name: 'Refund',
        meta: {
            pathName:  staticPath + 'refund'
        }
    },
    {
        path: staticPath + 'appeal',
        component: () => import('./pages/appeal/appeal.vue'),
        name: 'Appeal',
        meta: {
            pathName:  staticPath + 'appeal'
        }
    },
    {
        path: staticPath + 'specs',
        component: () => import('./pages/specs/specs.vue'),
        name: 'Specs',
        meta: {
            pathName:  staticPath + 'specs'
        }
    },
    {
        path: staticPath + 'addSpecs',
        component: () => import('./pages/specs/addSpecs.vue'),
        name: 'AddSpecs',
        meta: {
            pathName:  staticPath + 'specs'
        }
    },
    {
        path: staticPath + 'editSpecs/:id',
        component: () => import('./pages/specs/addSpecs.vue'),
        name: 'EditSpecs',
        meta: {
            pathName:  staticPath + 'specs'
        }
    },
    {
        path: staticPath + 'courseData',
        component: () => import('./pages/courseData/courseData.vue'),
        name: 'CourseData',
        meta: {
            pathName:  staticPath + 'courseData'
        }
    },
	{
	    path: staticPath + 'seckill',
	    component: Seckill,
	    meta: {
	        id: 15,
	        title: '秒杀活动',
	        pathName: staticPath + 'seckill'
	    }
	},
	{
	    path: staticPath + 'createSeckill',
	    component: CreateSeckill,
	    meta: {
	        title: '添加秒杀',
	        pathName: staticPath + 'seckill'
	    }
	},
    {
        path: staticPath + 'material',
        component: () => import('./pages/material/material.vue'),
        name: 'material',
        meta: {
            pathName:  staticPath + 'material'
        }
    },
    {
        path: staticPath + 'addMaterial',
        component: () => import('./pages/material/addMaterial.vue'),
        name: 'AddMaterial',
        meta: {
            pathName:  staticPath + 'material'
        }
    },
    {
        path: staticPath + 'editMaterial/:id',
        component: () => import('./pages/material/addMaterial.vue'),
        name: 'EditMaterial',
        meta: {
            pathName:  staticPath + 'material'
        }
    },
    {
        path: staticPath + 'msmService',
        component: () => import('./pages/privateDomainTools/msmService.vue'),
        name: 'msmService',
        meta: {
            pathName:  staticPath + 'msmService'
        }
    },
    {
        path: staticPath + 'msmServiceHistory',
        component: () => import('./pages/privateDomainTools/history/history.vue'),
        name: 'msmServiceHistory',
        meta: {
            pathName:  staticPath + 'msmService'
        }
    },
    {
        path: staticPath + 'leadManagement',
        component: () => import('./pages/privateDomainTools/leadManagement.vue'),
        name: 'leadManagement',
        meta: {
            pathName:  staticPath + 'leadManagement'
        }
    },
    {
        path: staticPath + 'leadManagementV2',
        component: () => import('./pages/privateDomainTools/leadManagementV2.vue'),
        name: 'leadManagementV2',
        meta: {
            pathName:  staticPath + 'leadManagementV2'
        }
    },
    {
        path: staticPath + 'privateStatistics',
        component: () => import('./pages/privateDomainTools/privateStatistics.vue'),
        name: 'privateStatistics',
        meta: {
            pathName:  staticPath + 'privateStatistics'
        }
    },
    {
        path: staticPath + 'relateLog',
        component: () => import('./pages/privateDomainTools/relateLog.vue'),
        name: 'relateLog',
        meta: {
            pathName:  staticPath + 'relateLog'
        }
    }
]
